var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-snackbar",
        {
          staticClass: "custom",
          attrs: { timeout: -1, right: "" },
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function ({ attrs }) {
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            return _vm.editItem(_vm.Item)
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Marcar como leído ")]
                  ),
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Cerrar ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _c("div", { staticClass: "ctn_notify" }, [
            _c("div", { staticClass: "ctn_header" }, [
              _c("div", { staticClass: "ctn_col_header" }, [
                _c("span", { staticClass: "_box_blue" }, [
                  _vm._v("IDX " + _vm._s(_vm.Item.idx) + " "),
                ]),
                _c("span", { staticClass: "_box_blue" }, [
                  _vm._v("NUI " + _vm._s(_vm.Item.nui)),
                ]),
              ]),
              _c("div", { staticClass: "ctn_col_header _der" }, [
                _c("span", { staticClass: "_box_red" }, [
                  _vm._v("Acción " + _vm._s(_vm.Item.action)),
                ]),
              ]),
            ]),
            _c("p", { staticClass: "ctn_notify_date" }, [
              _vm._v(_vm._s(_vm._f("formatDateFrom")(_vm.Item.date))),
            ]),
            _c("p", {
              staticClass: "ctn_notify_text",
              domProps: { innerHTML: _vm._s(this.Text) },
            }),
          ]),
          _c("div", { staticClass: "ctn_notify_footer" }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }